<div class="container">
    <div class="tenpxtop"></div>
    <!-- <div class="onboardtitle">Explore Your Next Adventure</div> -->
    <div class="row ">

        <div class="col-6 ">
            <div class=" instruction">Select a region</div>


            <div class="regionselection">

                <div class="funnelitemlist">

                    <select class="form-control" id="regionselector" name="regionselector" [(ngModel)]="selectedRegion"
                        (change)="setRegion(selectedRegion)">
                        <option value="" disabled selected>Choose a Region</option>
                        <option *ngFor="let region of CruiseRegionsInfo" [value]="region.creRegion">
                            {{region.creRegion}}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="col-6 ">
            <div class=" instruction">Select an Itinerary</div>

            <div class="itinereryselector">


                <div class="funnelitemlist">
                    <select class="form-control" id="Itinselector" name="Itinselector" [(ngModel)]="selectedItinerary"
                        (change)="setItinerary(selectedItinerary)">
                        <option value="" disabled selected>Choose an Itinerary</option>
                        <option *ngFor="let itinerary of CruiseItineraryInfo" [value]="itinerary.creRegionID">
                            {{itinerary.creItinerary}}
                        </option>
                    </select>
                </div>

            </div>
        </div>

        <div *ngIf="selectedItinerary!=undefined && ItinInfo!=undefined">
            <div class="itinname">{{displayselectedItinerary}}</div>
            <div class="intidesc" [innerHTML]="ItinInfo.MapDescription"></div>
            <div class="noborderaround">
                <div class="maplink lineitem">
                    <a *ngIf="!mapexpander" (click)="mapexpander = !mapexpander"><i
                            class="fa-solid fa-circle-plus fa-lg"></i><span class="dayslot timecollapse"></span>Map</a>
                    <a *ngIf="mapexpander" (click)="mapexpander = !mapexpander"><i
                            class="fa-solid fa-circle-minus fa-lg"></i><span class="dayslot timecollapse"></span>Map
                        <img class="mapdisplay" src={{ItinInfo.MapImageUrl}} /></a>
                </div>
            </div>



        </div>
        <div *ngIf="!reverselink && selectedItinerary!=undefined && ItinInfo!=undefined">
            <div class="highlight" *ngFor="let daylist of ItinInfo.StandardDays; let i=index;">
                <div
                    [ngClass]="{'borderaround': daylist.highlightexpander === true,'noborderaround':daylist.highlightexpander === false || daylist.highlightexpander == undefined}">
                    <div class="lineitem">

                        <a *ngIf="!daylist.highlightexpander"
                            (click)="daylist.highlightexpander = !daylist.highlightexpander"><i
                                class="fa-solid fa-circle-plus fa-lg"></i><span class="dayslot"><span
                                    class="timecollapse" *ngIf="daylist.Day == '0'">Pre Cruise</span><span
                                    *ngIf="daylist.Day != '0'" class="timecollapse">Day {{daylist.Day}}</span> <span
                                    class="activityname" [innerHTML]="daylist.Location"></span></span></a>
                        <a *ngIf="daylist.highlightexpander"
                            (click)="daylist.highlightexpander = !daylist.highlightexpander"><i
                                class="fa-solid fa-circle-minus fa-lg"></i><span class="dayslot"><span
                                    class="timecollapse" *ngIf="daylist.Day == '0'">Pre Cruise</span><span
                                    class="timeexpand" *ngIf="daylist.Day != '0'">Day {{daylist.Day }} </span><span
                                    class="activityname activitynameexpand"
                                    [innerHTML]="daylist.Location"></span></span></a>
                    </div>
                    <div class="row innerexpand" *ngIf="daylist.highlightexpander==true">
                        <div class="col-12">

                            <div class="activitydesc" [innerHTML]="daylist.Description"></div>


                        </div>
                        <div>
                            <div *ngFor="let dayexcursion of daylist.ExcursionIds;let i=index;">

                                <div *ngFor="let excursion of excursionmap | keyvalue">
                                    <li *ngIf="excursion.key == dayexcursion"> <span
                                            (click)="showexcursion(excursion.value)"
                                            class="excursionlink">{{excursion.value.Title}}</span></li>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </div>
        <div *ngIf="reverselink && selectedItinerary!=undefined && ItinInfo!=undefined">
            <div class="highlight" *ngFor="let daylist of ItinInfo.ReverseDays; let i=index;">
                <div
                    [ngClass]="{'borderaround': daylist.highlightexpander === true,'noborderaround':daylist.highlightexpander === false || daylist.highlightexpander == undefined}">
                    <div class="lineitem">

                        <a *ngIf="!daylist.highlightexpander"
                            (click)="daylist.highlightexpander = !daylist.highlightexpander"><i
                                class="fa-solid fa-circle-plus fa-lg"></i><span class="dayslot"><span
                                    class="timecollapse" *ngIf="daylist.Day == '0'">Pre Cruise</span><span
                                    *ngIf="daylist.Day != '0'" class="timecollapse">Day {{daylist.Day}}</span> <span
                                    class="activityname" [innerHTML]="daylist.Location"></span></span></a>
                        <a *ngIf="daylist.highlightexpander"
                            (click)="daylist.highlightexpander = !daylist.highlightexpander"><i
                                class="fa-solid fa-circle-minus fa-lg"></i><span class="dayslot"><span
                                    class="timecollapse" *ngIf="daylist.Day == '0'">Pre Cruise</span><span
                                    class="timeexpand" *ngIf="daylist.Day != '0'">Day {{daylist.Day }} </span><span
                                    class="activityname activitynameexpand"
                                    [innerHTML]="daylist.Location"></span></span></a>
                    </div>
                    <div class="row innerexpand" *ngIf="daylist.highlightexpander==true">
                        <div class="col-12">

                            <div class="activitydesc" [innerHTML]="daylist.Description"></div>


                        </div>
                        <div>
                            <div *ngFor="let dayexcursion of daylist.ExcursionIds;let i=index;">

                                <div *ngFor="let excursion of excursionmap | keyvalue">
                                    <li *ngIf="excursion.key == dayexcursion"> <span
                                            (click)="showexcursion(excursion.value)"
                                            class="excursionlink">{{excursion.value.Title}}</span></li>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </div>
        <div *ngIf="selectedItinerary!=undefined && ItinInfo!=undefined">
            <div class="reverselink" (click)="reverselink = !reverselink" *ngIf="ItinInfo.ReverseDays.length>0">See
                Reverse Schedule</div>
        </div>
        <div *ngIf="selectedItinerary!=undefined && ItinInfo!=undefined && !OBRebookMaint">
            <button class="btn btn-light nav-item nav-link-edit" [routerLink]="['/rebook']"
                [queryParams]="{region: selectedRegion,itin:selectedItinerary}">Book This
                Itinerary</button>
        </div>
        <div *ngIf="selectedItinerary!=undefined && ItinInfo!=undefined && OBRebookMaint">
            <span class="mainmessage">We are unable to book this itinerary at this time due to planned system
                maintenance, please try again later.</span>
        </div>


    </div>
</div>